// Sticky "Filter & sort" bar: sticks under the header and moves in step with the sub-menu.
// When the sub-menu glides away on scroll down, the bar glides up to the header; it glides back on scroll up.
// Uses transform only so the motion stays smooth on phones.
const subBar = document.querySelector('[data-subheader]');
const subInner = subBar && subBar.querySelector('[data-subheader-inner]');
const header = subBar ? subBar.parentElement.closest('.sticky') || subBar.parentElement : document.querySelector('header');

let toolbar = null;
let sentinel = null;
let ticking = false;
let lastTop = -1;

const subHeight = () => (subInner ? subInner.offsetHeight : 0);
// Where the pinned header really ends on screen. The announcement bar above the header is pinned too, so the header's own height alone is too short.
const headerHeight = () => (header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0);

const refresh = () => {
  if (!toolbar || !toolbar.isConnected) toolbar = document.querySelector('[data-sticky-toolbar]');
  if (!sentinel || !sentinel.isConnected) sentinel = document.querySelector('[data-sticky-toolbar-sentinel]');
  if (!toolbar) return;

  const sub = subHeight();
  const top = headerHeight() + sub;
  // Only write the page-wide value when it changes, so scrolling doesn't restyle the whole page every frame.
  if (top !== lastTop) {
    lastTop = top;
    document.documentElement.style.setProperty('--sticky-toolbar-top', `${top}px`);
  }

  const stuck = sentinel ? sentinel.getBoundingClientRect().top < top - 1 : false;
  const subHidden = subBar ? subBar.hasAttribute('data-hidden') : true;

  const wasStuck = toolbar.hasAttribute('data-stuck');
  const transform = stuck && subHidden && sub ? `translateY(-${sub}px)` : '';
  toolbar.toggleAttribute('data-stuck', stuck);
  if (stuck !== wasStuck) {
    // The moment the bar starts or stops sticking, snap it into place without the glide, so no gap
    // opens above it and it doesn't jump. The glide stays for the menu bar sliding in and out.
    toolbar.style.transition = 'none';
    toolbar.style.transform = transform;
    void toolbar.offsetHeight;
    requestAnimationFrame(() => toolbar.style.removeProperty('transition'));
  } else if (toolbar.style.transform !== transform) {
    toolbar.style.transform = transform;
  }
};

const schedule = () => {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(() => {
    ticking = false;
    refresh();
  });
};

window.addEventListener('scroll', schedule, { passive: true });
window.addEventListener('resize', schedule);
if (subBar) new MutationObserver(schedule).observe(subBar, { attributes: true, attributeFilter: ['data-hidden'] });
refresh();
